import {
  INSTALLATION_CUSTOMER_DUTY_OPTIONS,
  type InstallationCustomerDutyKey,
  type InstallationCustomerDutyState,
} from '../../types'
import { wonFormCheckInput, wonFormCheckLabel, wonFormCheckRow } from '../../formCheckClasses'

interface Props {
  isView: boolean
  customerDuty: InstallationCustomerDutyState
  toggleCustomerDuty: (key: InstallationCustomerDutyKey) => void
  updateCustomerDuty: (patch: Partial<InstallationCustomerDutyState>) => void
}

const InstallationCustomerDutySection: React.FC<Props> = ({
  isView,
  customerDuty,
  toggleCustomerDuty,
  updateCustomerDuty,
}) => {
  const standardOptions = INSTALLATION_CUSTOMER_DUTY_OPTIONS.filter(o => o.key !== 'other')
  const otherOption = INSTALLATION_CUSTOMER_DUTY_OPTIONS.find(o => o.key === 'other')!

  return (
    <div className='col-12'>
      <div className='card'>
        <div className='card-header'>
          <div className='card-title fw-bold'>ลูกค้ารับผิดชอบ</div>
        </div>
        <div className='card-body'>
          <div className='row gy-3'>
            {standardOptions.map(({ key, label }) => (
              <div key={key} className='col-12 col-md-6 col-xl-4'>
                <div className={wonFormCheckRow}>
                  <input
                    className={wonFormCheckInput}
                    type='checkbox'
                    id={`won-install-duty-${key}`}
                    checked={customerDuty[key]}
                    disabled={isView}
                    onChange={() => toggleCustomerDuty(key)}
                  />
                  <label className={wonFormCheckLabel} htmlFor={`won-install-duty-${key}`}>
                    {label}
                  </label>
                </div>
              </div>
            ))}
            <div className='col-12 col-md-6 col-xl-4'>
              <div className='d-flex flex-nowrap align-items-center gap-2'>
                <div className={`${wonFormCheckRow} flex-shrink-0`}>
                  <input
                    className={wonFormCheckInput}
                    type='checkbox'
                    id='won-install-duty-other'
                    checked={customerDuty.other}
                    disabled={isView}
                    onChange={() => toggleCustomerDuty('other')}
                  />
                  <label className={wonFormCheckLabel} htmlFor='won-install-duty-other'>
                    {otherOption.label}
                  </label>
                </div>
                <input
                  type='text'
                  className='form-control form-control-sm'
                  placeholder='ระบุ'
                  value={customerDuty.otherText}
                  disabled={isView || !customerDuty.other}
                  onChange={e => updateCustomerDuty({ otherText: e.target.value })}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InstallationCustomerDutySection
